import { ReactNode, useEffect } from 'react';

import { CircularProgressFullScreen } from '../../components/CircularProgressFullScreen/CircularProgressFullScreen';
import useLeadChannelStore from '../../store/leadChannelStore/useLeadChannelStore';

const CmsGuard = ({ children }: { children: ReactNode }): ReactNode => {
  const { initLeadChannelFinished, initLeadChannel } = useLeadChannelStore();

  useEffect((): void => {
    initLeadChannel();
  }, [initLeadChannel]);

  if (!initLeadChannelFinished) {
    return <CircularProgressFullScreen />;
  }

  return children;
};

export default CmsGuard;
